import { useState } from 'react';
import styles from './ResetPassword.module.css';
import { API_BASE } from "../../config/api";

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

 const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setMessage("");

  try {
    const response = await fetch(API_BASE+"/api/password-reset", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const result = await response.text();
    setMessage(result);
  } catch (error) {
    setMessage("There was a problem sending the email.");
  }
};

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <h2 className={styles.title}>Reset Password</h2>
        <p className={styles.subtitle}>Enter your email address to reset your password.</p>

        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className={styles.input}
        />

        <button type="submit" className={styles.button}>
        Reset
        </button>

        {message && <p className={styles.message}>{message}</p>}
      </form>
    </div>
  );
}